import React, { useEffect, useState } from 'react';
import ProzoDataGrid, { lastPageRowCount, useFirstPageOnChange } from "../../../common/ProzoDataGrid";
import NetraScoreBadge from "../NetraScoreBadge";
import RtoRiskBadge from "../RtoRiskBadge";
import { Chip, Grid, Button, Typography, Box, Link as MuiLink, Stack, Tooltip, IconButton, Menu, MenuItem, ListItemIcon, ListItemText } from '@mui/material';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import SyncIcon from '@mui/icons-material/Sync';
import { useDispatch, useSelector } from 'react-redux';
import { getOrderLists, syncOrder } from '../../../redux/actions/orderList/orderListAction';
import { resetOrderList } from '../../../redux/reducers/orderList/orderListSlice';
import Loader from '../../../common/Loader';
import { parseDateAndTime, getTotalUnitsOfOrder, formatDate, formatCurrency } from '../../../helpers/UtilityHelper';
import { exclude, ItemListModal } from './index';
import { orderStatusClause } from './OrderStatusFilter';
import { Link } from 'react-router-dom'
import { primaryTextSx, secondaryTextSx, tertiaryTextSx, awbTextSx, cellStackSx, getStatusChipSx, getPaymentChipSx } from './cellStyles';
import ClientOrderIdText, { clientOrderIdClause } from './ClientOrderIdText';
import AwbLinkCell from '../../../common/AwbLinkCell';
import { abdFlagFilter } from '../../appointments/shared/constants';
import useCourierServiceType from '../../../hooks/useCourierServiceType';

const DeliveryFailedOrders = (props) => {
  const dispatch = useDispatch();
  const { orderListInfo, loading } = useSelector((state) => state.orderListSlice);
  const { loading: orderSummaryLoading } = useSelector((state) => state.orderSummarySlice);
  const [page, setPage] = useState(0);
  const [sizePerPage, setSizePerPage] = useState(10);
  // New filters applied: start again from the first page.
  useFirstPageOnChange(props.filterChange, setPage);
  const [rowCountState, setRowCountState] = useState(props?.count || 0);
  const [itemModal, setItemModal] = useState(false);
  const [itemModalData, setItemModalData] = useState();
  const [actionMenu, setActionMenu] = useState(null);
  const closeActionMenu = () => setActionMenu(null);
  const runFromMenu = (fn) => () => { fn?.(); closeActionMenu(); };
  const { getServiceType } = useCourierServiceType();

  useEffect(() => {
    const andfilter = [];
    const orFilter = [];

    if (props.merchantId) {
      andfilter.push({
        field: "merchant.$id",
        operator: "eq",
        value: props.merchantId,
      });
    }
    const statusClause = orderStatusClause(props.filters.status);
    if (statusClause) {
      andfilter.push(statusClause)
    } else {
      andfilter.push({ "field": "orderStatus", "operator": "in", "value": ['FAILED_DELIVERY'] });
    }
    andfilter.push({ field: "shipmentType", operator: "eq", value: props.shipmentType });
    if (props.filters?.appointdeliveryRequired !== undefined && props.filters?.appointdeliveryRequired !== null && props.filters?.appointdeliveryRequired !== '') {
      andfilter.push(abdFlagFilter(props.filters.appointdeliveryRequired));
    }

    if (props.shipmentType === 'B2C') {
      andfilter.push({ field: "orderType", operator: "eq", value: 'FORWARD SHIPMENT' });
    }

    // if (!(props.filters.fromDate && props.filters.toDate)) {
    //   andfilter.push({ field: "awbRegisteredDate", operator: "gte", value: props.startDateForLastThirtyDays })
    // }

    if (props.filters) {
      // if (props.filters.reference) {
      //   andfilter.push({ "field": "reference", "operator": "eq", "value": props.filters.reference });
      // }
      const clientOrderFilter = clientOrderIdClause(props.filters);
      if (clientOrderFilter) {
        andfilter.push(clientOrderFilter);
      }
      if (props.filters.awb) {
        andfilter.push({ "field": "awbNumber", "operator": "eq", "value": props.filters.awb });
      }
      if (props.filters.payment_mode) {
        andfilter.push({
          field: "paymentMode",
          operator: "eq",
          value: props.filters.payment_mode,
        });
      }
      if (props.filters.city) {
        andfilter.push({ "field": "deliveryDetails.to_city", "operator": "eq", "value": props.filters.city });
      }
      if (props.filters.state) {
        andfilter.push({ "field": "deliveryDetails.to_state", "operator": "eq", "value": props.filters.state });
      }
      if (props.filters) {
        if (props.filters.reference) {
          orFilter.push({ "field": "reference", "operator": "eq", "value": props.filters.reference });
        }
        if (props.filters.reference) {
          orFilter.push({ "field": "shippingLabelId", "operator": "eq", "value": props.filters.reference });
        }

      }
      if (props.filters.fromDate) {
        andfilter.push({
          field: "awbRegisteredDate", operator: "gte",
          //  value: formatDateForApi(props.filters.fromDate)
          value: `Date('${formatDate(props.filters.fromDate, 'yyyy-MM-dd')} 00:00:00')`
        })
      }
      if (props.filters.toDate) {
        andfilter.push({
          field: "awbRegisteredDate", operator: "lte",
          // value: formatDateForApi(props.filters.toDate) 
          value: `Date('${formatDate(props.filters.toDate, 'yyyy-MM-dd')} 23:59:59')`
        })
      }
    }

    dispatch(resetOrderList());
    dispatch(getOrderLists({ "excludes": exclude, "andfilter": andfilter, "orfilter": orFilter, "offset": (page * sizePerPage), "limit": sizePerPage, "skipCount": true, "sort": { "field": "awbRegisteredDate", "direction": "DESC" } }));
    setRowCountState(props.count ? props.count : Number.MAX_VALUE);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page, sizePerPage, props.filterChange]);

  const handleSync = (awbNumber, reference) => {
    if (awbNumber) {
      dispatch(syncOrder({ waybill: awbNumber, reference: reference }));
    }
  }

  const columns = [
    {
      field: 'det', headerAlign: "center", hideSortIcons: true, headerName: 'Order Details', flex: 1.3, minWidth: 160, renderCell: (params) => {
        const { row } = params;
        return (
          <Box sx={cellStackSx}>
            <Typography sx={primaryTextSx}>{row.reference}</Typography>
            {row.shippingLabelId && row.reference !== row.shippingLabelId && (
              <Typography sx={secondaryTextSx}>{row.shippingLabelId}</Typography>
            )}
            <ClientOrderIdText row={row} />
            <Typography sx={secondaryTextSx}>
              {row.createdDate ? parseDateAndTime(row.createdDate) : ""}
            </Typography>
            {row.channel_name && row.channel_name !== 'Unicom' && row.channel_name !== 'WMS' && (
              <Typography sx={tertiaryTextSx}>{row.channel_name}</Typography>
            )}
          </Box>
        )
      },
    },
    {
      field: "courier", headerAlign: "center", hideSortIcons: true, headerName: "Courier Partner", flex: 1, minWidth: 140,
      renderCell: (params) => {
        const { row } = params;
        let courierParent = row.courierDetail?.parent?.includes('Blended') ? row.actualCourierProviderName : row.courierDetail?.parent;
        const serviceType = getServiceType(row.courierDetail?.prozoId);
        return (
          <Box sx={cellStackSx}>
            <AwbLinkCell awb={row.awb_number} sx={awbTextSx} />
            <Typography sx={secondaryTextSx}>{courierParent}</Typography>
            {serviceType && <Typography sx={tertiaryTextSx}>{serviceType}</Typography>}
          </Box>
        );
      },
    },
    {
      field: 'pickup', headerAlign: "center", hideSortIcons: true, headerName: 'Pickup Details', flex: 1.3, minWidth: 150, renderCell: (params) => {
        const { row } = params;
        return (
          <Box sx={cellStackSx}>
            <Typography sx={primaryTextSx}>{row.pickup_details.from_name}</Typography>
            <Typography sx={secondaryTextSx}>
              {row.pickup_details.from_city}, {row.pickup_details.from_pincode}
            </Typography>
          </Box>
        )
      },
    },
    {
      field: 'delivery', headerAlign: "center", hideSortIcons: true, headerName: 'Delivery Details', flex: 1.6, minWidth: 180, renderCell: (params) => {
        const { row } = params;
        return (
          <Box sx={cellStackSx}>
            <Typography sx={primaryTextSx}>{row.delivery_details.to_name}</Typography>
            <Typography sx={secondaryTextSx}>{row.delivery_details.to_phone_number}</Typography>
            <Typography sx={tertiaryTextSx}>
              {row.delivery_details.to_city}, {row.delivery_details.to_state}, {row.delivery_details.to_pincode}
            </Typography>
            {row.netra_address && (
              <Box sx={{ mt: 0.3 }}><NetraScoreBadge netra={row.netra_address} orderId={row.id} /></Box>
            )}
            {row.netra_rto && (
              <Box sx={{ mt: 0.3 }}><RtoRiskBadge netra={row.netra_rto} orderId={row.id} /></Box>
            )}
          </Box>
        )
      },
    },
    {
      field: 'itemDetails', headerAlign: "center", hideSortIcons: true, headerName: 'Item Details', flex: 0.7, minWidth: 90, renderCell: (params) => {
        const { row } = params;
        return (
          <Box sx={cellStackSx}>
            <Typography sx={primaryTextSx}>{getTotalUnitsOfOrder(row.item_list)} units</Typography>
            <MuiLink
              component="button"
              variant="body2"
              sx={{ fontSize: 11, textDecoration: 'none', '&:hover': { textDecoration: 'underline' } }}
              onClick={() => { setItemModalData(row.item_list); setItemModal(true); }}
            >
              View Items
            </MuiLink>
          </Box>
        )
      },
    },
    {
      field: 'paymentDetails', headerAlign: "center", hideSortIcons: true, headerName: 'Payment Details', flex: 0.7, minWidth: 100, renderCell: (params) => {
        const { row } = params;
        const paymentMode = row.payment_mode || '';
        return (
          <Box sx={cellStackSx}>
            <Typography sx={primaryTextSx}>{row.invoice_value ? formatCurrency(row.invoice_value) : ""}</Typography>
            {paymentMode && <Chip size="small" label={paymentMode} sx={getPaymentChipSx(paymentMode)} />}
          </Box>
        )
      },
    },
    {
      field: 'statusDetails', headerAlign: "center", hideSortIcons: true, headerName: 'Status', flex: 1, minWidth: 120, renderCell: (params) => {
        const { row } = params;
        return <Chip size="small" label={row.orderStatus} sx={getStatusChipSx(row.orderStatus)} />;
      },
    },
    {
      field: 'action', headerAlign: "center", hideSortIcons: true, headerName: 'Action', flex: 1.1, minWidth: 160, renderCell: (params) => {
        const { row } = params;
        return (
          <Stack direction="row" spacing={0.5} alignItems="center" justifyContent="center" sx={{ width: '100%' }}>
            <Button variant="contained" size="small" component={Link}
              to={`/order-detail?waybill=${row.awb_number}`}
              target="_blank" rel="noopener noreferrer"
              sx={{ whiteSpace: 'nowrap', textTransform: 'none', fontWeight: 600, px: 2, fontSize: 12 }}
            >Details</Button>
            <Tooltip title="More actions">
              <IconButton size="small" onClick={(e) => setActionMenu({ anchorEl: e.currentTarget, row })}
                sx={{ bgcolor: 'background.paper', border: '1px solid', borderColor: 'divider', borderRadius: 1, width: 32, height: 32, '&:hover': { bgcolor: 'grey.100' } }}>
                <MoreVertIcon fontSize="small" />
              </IconButton>
            </Tooltip>
          </Stack>
        )
      },
    },
  ];

  useEffect(() => {
    setRowCountState((prevRowCountState) =>
      props?.count !== undefined ? props?.count : prevRowCountState,
    );
  }, [props?.count, setRowCountState]);

  return (
    <>
      <Grid item container spacing={2}>
        {(loading || orderSummaryLoading) && <Loader />}
        <Grid item xs={12}>
          <ProzoDataGrid columns={columns}
            hideFooterPagination={false}
            // disableColumnFilter={true}rowsPerPageOptions
            autoHeight={true}
            rows={(orderListInfo.data && orderListInfo.data.length > 0) ? orderListInfo.data : []}
            sizePerPage={sizePerPage}
            setSizePerPage={setSizePerPage}
            setPage={setPage}
            page={page}
            pagination={true}
            filterMode={"server"}
            rowCount={lastPageRowCount({ page, pageSize: sizePerPage, rowsOnPage: orderListInfo?.data?.length, loading })}
            getRowId={(row) => row.id} />
        </Grid>
      </Grid>

      <ItemListModal data={itemModalData} itemModal={itemModal} setItemModal={setItemModal} />
      <Menu anchorEl={actionMenu?.anchorEl} open={Boolean(actionMenu)} onClose={closeActionMenu}
        PaperProps={{ sx: { minWidth: 200, '& .MuiMenuItem-root': { fontSize: 12, py: 0.75 }, '& .MuiListItemText-primary': { fontSize: 12 }, '& .MuiListItemIcon-root': { minWidth: 28 } } }}>
        <MenuItem onClick={runFromMenu(() => handleSync(actionMenu?.row?.awb_number, actionMenu?.row?.reference))}>
          <ListItemIcon><SyncIcon fontSize="small" /></ListItemIcon>
          <ListItemText>Resync</ListItemText>
        </MenuItem>
      </Menu>
    </>
  );
};

export default DeliveryFailedOrders
